/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpportunityFieldData
 */
export interface OpportunityFieldData {
    /**
     * 
     * @type {string}
     * @memberof OpportunityFieldData
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof OpportunityFieldData
     */
    required: boolean;
}

/**
 * Check if a given object implements the OpportunityFieldData interface.
 */
export function instanceOfOpportunityFieldData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "required" in value;

    return isInstance;
}

export function OpportunityFieldDataFromJSON(json: any): OpportunityFieldData {
    return OpportunityFieldDataFromJSONTyped(json, false);
}

export function OpportunityFieldDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityFieldData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'required': json['required'],
    };
}

export function OpportunityFieldDataToJSON(value?: OpportunityFieldData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'required': value.required,
    };
}

